type RuntimeImportMetaEnv = Partial<Record<'PROD', string | boolean | undefined>>;

const importMetaEnv = ((import.meta as ImportMeta & { env?: RuntimeImportMetaEnv }).env ?? {}) as RuntimeImportMetaEnv;
const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '0.0.0.0', '[::1]']);

export function isProductionRuntime() {
  if (importMetaEnv.PROD === true || importMetaEnv.PROD === 'true') {
    return true;
  }

  if (typeof process !== 'undefined' && process.env.NODE_ENV === 'production') {
    return true;
  }

  if (typeof window !== 'undefined') {
    return !LOCAL_HOSTNAMES.has(window.location.hostname);
  }

  return false;
}